<template>
  <div></div>
</template>

<script>
import { useAuth0 } from "@auth0/auth0-vue";
import { useRouter } from "vue-router";
export default {
  async setup() {
    const auth0 = useAuth0();
    //    const router = useRouter();
    if (auth0.isLoading.value || auth0.isAuthenticated.value) {
      //      router.push("/account");
      window.location.href = window.location.origin + "/monitoring";
    } else {
      // invitation時の処理
      if (window.location.search.includes("invitation=")) {
        const params = new URLSearchParams(window.location.search);
        const invitation = params.get("invitation");
        localStorage.organization_name = params.get("organization_name");
        localStorage.organization = params.get("organization");
        auth0.loginWithRedirect({
          invitation: invitation,
        });
      } else {
        //標準はspecteeの組織を使用
        //var organization = "org_0DIHs9gDDXd7DVxf";
        //ローカルストレージに組織保存されていた場合はそちらを使用
        if (localStorage.organization) {
          const organization = localStorage.organization;
          auth0.loginWithRedirect({
            organization: organization,
            redirect_uri: window.location.origin + "/monitoring/",
            //            appState: {
            //              target: "/account",
            //            },
          });
        } else {
          auth0.loginWithRedirect({
            redirect_uri: window.location.origin + "/monitoring/",
            //            appState: {
            //              target: "/account",
            //            },
          });
        }

        //        const { appState } = await auth0.handleRedirectCallback();
        //        const redirectUrl = appState.target;
        //        window.location.href = redirectUrl;
      }
    }
  },
};
</script>
